import { twJoin } from "tailwind-merge";

import { ChatMessageRole } from "src/base-components/Chat/types";

type ChatMessageProps = {
  role: ChatMessageRole;
  children: React.ReactNode;
  dataLoc?: string;
  ref?: React.Ref<HTMLLIElement>;
};

export const ChatMessage: React.FC<ChatMessageProps> = ({
  role,
  children,
  dataLoc,
  ref,
}) => {
  const isUserMessage = role === "user";

  return (
    <li ref={ref} className="group flex flex-col gap-y-1" data-loc={dataLoc}>
      <div
        className={twJoin(isUserMessage && "flex w-full flex-col items-end")}
      >
        {children}
      </div>
    </li>
  );
};
